import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";

type DeleteTemplateModalProps = {
  isOpen: boolean;
  close: () => void;
  templateName: string;
  isLoading: boolean;
  onConfirm: () => void;
};

export const DeleteTemplateModal = ({
  isOpen,
  close,
  templateName,
  isLoading,
  onConfirm,
}: DeleteTemplateModalProps) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Delete template?</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-text-body-lg t-text-text-black">
            Are you sure you want to delete <strong>{templateName}</strong>?
            This action cannot be undone.
          </div>
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button type="button">Cancel</Button>
          </Modal.RawClose>
          <Button
            customType="danger"
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Delete
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
